module.exports = __webpack_public_path__ + "img/status-bus.fed425cc.svg";